import { Box, HStack, Text, VStack } from "@chakra-ui/react";
import React from "react";

import { DeepPick } from "../../../../types";
import { AiInterviewEvaluationFragment } from "../../../graphql";
import { getQuestionScoreCounts } from "./scoring";

type QuestionScoreCountsProps = {
  evaluation: DeepPick<AiInterviewEvaluationFragment, "questions", "points">;
};

export const QuestionScoreCounts: React.FC<QuestionScoreCountsProps> = ({
  evaluation,
}) => {
  const colors = getQuestionScoreCounts(evaluation);

  return (
    <HStack spacing="2">
      {colors.map(({ color, count }) => (
        <VStack key={color} spacing="1">
          <Box w="12px" h="12px" borderRadius="full" bg={color} />
          <Text fontSize="xs" color="gray.600">
            {count}
          </Text>
        </VStack>
      ))}
    </HStack>
  );
};
